import Settings from "lib/types/Settings";
import Link from "next/link";
import styles from "./AllCultureShowsLink.module.css";


//#region [Props]
type AllShowsLinkProps = {
    settings: Settings;
    showAllShowsFunction?: () => void;
    userOverriddenLinkText?: string;
};
//#endregion

//#region [Component]
export default function AllCultureShowsLink({ settings, showAllShowsFunction, userOverriddenLinkText }: AllShowsLinkProps) {
    return <div className={styles.SLinkContainer}>
        {!showAllShowsFunction && <Link href="/kulturprogram" passHref legacyBehavior>
            <a className={styles.SAllCultureShowsLink}>
                {userOverriddenLinkText ?? settings.text_allshows_culture ?? "Se hele kulturprogrammet"}
            </a>
        </Link>}
        {showAllShowsFunction && <button className={styles.SAllCultureShowsLink} onClick={showAllShowsFunction}>{settings.text_allshows_culture ?? "Se hele kulturprogrammet"}</button>}
    </div>
}
//#endregion